import { render, staticRenderFns } from "./SlotsPicker.vue?vue&type=template&id=fd252ec4&"
import script from "./SlotsPicker.controller.js?vue&type=script&lang=js&"
export * from "./SlotsPicker.controller.js?vue&type=script&lang=js&"
import style0 from "./SlotsPicker.styles.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports